let chatButton;

export function loadZendesk(siteCountryCode) {
  // Add Zendesk script to the page. This needs to be added dynamically since it's supposed to be
  // included AFTER Pendo loads
  if (siteCountryCode) {
    const zendeskScript = document.createElement('script');
    const zendeskKey = siteCountryCode === 'GB'
      ? '1f40190f-4a3b-4308-b222-fdb0a882f310'
      : '69139f7f-d202-4995-a641-71cc8f171dae';

    zendeskScript.id = 'ze-snippet';
    zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    document.body.appendChild(zendeskScript);
  }
}

function checkIfZoomChatIsLoaded(callback) {
  if (!document.querySelector('div[data-tag=web-chat-sdk-shadow]')?.shadowRoot) {
    // If the shadow dom hasn't loaded in yet, wait and check again
    window.setTimeout(() => checkIfZoomChatIsLoaded(callback), 100);
  } else {
    // The shadow dom has loaded; we can open the chat pane if it hasn't opened itself already
    callback();
    const chatIsClosed = !!document.querySelector('div[data-tag=web-chat-sdk-shadow]').shadowRoot.querySelector('.livesdk__chat-sdk-window--closed');
    if (chatIsClosed) {
      chatButton.click();
    }
  }
}

/**
 * @param {Function} callback - Callback for after the Zoom scripts have loaded _and_ the chat pane is available
 */
export function loadZoomAgent(callback) {
  chatButton = document.getElementById('zoom-help-button');

  const zoomScript = document.createElement('script');
  zoomScript.setAttribute('data-apikey', 'z8zeU64oTYauNAr7l3bCbQ');
  zoomScript.setAttribute('data-env', 'us01');
  zoomScript.onload = () => {
    // Wait for the script to load, then check if the chat pane opened (i.e. the user
    // had previously started a chat). Otherwise open it.
    window.setTimeout(() => checkIfZoomChatIsLoaded(callback), 100);
  };
  zoomScript.src = 'https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js';

  document.body.appendChild(zoomScript);
}
